import { FlexRow } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledChartWrapper = styled(FlexRow)<{ isLoading: boolean }>`
    justify-content: center;
    width: auto;

    pointer-events: ${({ isLoading }) => (isLoading ? "none" : "auto")};
`;
